import { Navigate } from "react-router-dom";
//import { useAuth } from "../context/AuthProvider";
import { useAuth } from "../context/AuthContext";


export default function PrivateRoute({ children }) {
  const { user, token } = useAuth();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}